<template>
  <div class="layout">
    <vue-progress-bar/>
    <div class="layout__nav">
      <navbar/>
    </div>
    <div class="layout__content">
      <div class="layout__padding">
        <div class="layout__title">
          <h1 class="h3 text--uppercase">{{titulo}}</h1>
        </div>
        <router-view/>
        <p class="text text--grisa text--extra-small
           text--center text--italic version">Versión: {{ version }}</p>
      </div>
    </div>
  </div>
</template>

<script>
import D from "debug";
import get from "lodash/get";
import Navbar from "./navegacion/Navbar.vue";
import pkg from "../../package.json";

const debug = D("ciris:Home.vue");

export default {
  name: "Home",
  components: { Navbar },
  computed: {
    version,
  },
  data,
  watch: {
    $route: route,
  },
  created,
};

function data() {
  return {
    estaMostrado: false,
    titulo: prepararTitulo(this.$router.currentRoute),
  };
}

function route(val) {
  this.titulo = prepararTitulo(val);
}

function prepararTitulo(val) {
  return get(val, "meta.titulo", "");
}

function created() {
  debug("Home created");
  this.$router.push("formularios");
}

function version() {
  return pkg.version;
}
</script>

<style lang="scss">
  @import "~Sass/variables";
  $paddingNav: 60px;
  body{
  }

  .layout {
    display: flex;
    flex-direction: column;
    overflow: hidden;
  }

  .layout__nav{
    position: fixed;
    top: 0;
    left: 0;
    background: $uacfel-verdeagua;
    box-shadow: 0 4px 2px -1px transparentize($negro4, .5);
    width: 100%;
    height: 54px;
    z-index: 5;
  }

  .layout__title > .h3{
    color: darken($uacfel-verdeagua, 8%);
    margin: 0;
    margin-bottom: .5em;
  }

  .layout__content{
    display: flex;
    flex-direction: row;
    min-height: 100vh;
    flex-grow: 2;
    width: 100%;
    background: $blanco;
    background-size: cover;
    position: relative;
  }

  .layout__padding {
    padding: 1em;
    margin-top: $paddingNav;
    height: 100%;
    width: 100%;
    flex-grow: 2;
    @media (min-width: $reflex-md ) {
      padding: 1em 3em;
    }
  }

  .menu__version{
    pointer-events: none;
    line-height: 24px;
    padding: 0 .35em;
    user-select: none;
    display: block;
  }

  .botones-pagina{
    position: fixed;
    top: .5em;
    left: 0;
    text-align: center;
    width: 100%;
    padding-bottom: 1em;
    margin-bottom: .5em;
    pointer-events: none;
    z-index: 6;
    * {
      pointer-events: auto;
    }
  }

  .version{
    position: fixed;
    bottom: 2px;
    right: 8px;
  }
</style>
